import { render, staticRenderFns } from "./MainMenuButton.vue?vue&type=template&id=75b859f6&scoped=true"
import script from "./MainMenuButton.vue?vue&type=script&lang=js"
export * from "./MainMenuButton.vue?vue&type=script&lang=js"
import style0 from "./MainMenuButton.vue?vue&type=style&index=0&id=75b859f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b859f6",
  null
  
)

export default component.exports